import "./projects-page.css";
import ProjectsCarousel from "../components/Projects-carousel";


export default function ProjectsPage() {
    return <div className="container">
        <h1 className="project-header">Personal Projects</h1>
        <ProjectsCarousel />
        </div>
}